// extracted by mini-css-extract-plugin
module.exports = {"promo":"PDPPromoArea_promo__6YQ_k","fullWidth":"PDPPromoArea_fullWidth__078YW"};